module.exports = __webpack_public_path__ + "media/394477__gameloops__gamepack1-main-horrible-finish.fe0c68b9.mp4";